import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('avEcoAccessToken');
  
  /*
    Check if token exists
    Also check token validity here
  */

  if (!token) {
    // If no token, redirect to login
    return <Navigate to="/login" />;
  }

  return children; // Render protected content if token exists
};

export default ProtectedRoute;
